import { render, staticRenderFns } from "./PillLightButtons.vue?vue&type=template&id=b59bb24e"
import script from "./PillLightButtons.vue?vue&type=script&lang=js"
export * from "./PillLightButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports